import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { Company } from './company.model';
import { CompaniesStore } from './companies.store';
import { SbEvent, SbEventBusService } from '@services';
import { Subject } from 'rxjs';
import { AppConfigQuery } from '../../../core/state/app-config/app-config.query';

@Injectable({ providedIn: 'root' })
export class CompaniesService implements OnDestroy {
    unsubscribe$ = new Subject();
    constructor(
        private companiesStore: CompaniesStore,
        private http: HttpClient,
        private config: AppConfigQuery,
        private sbEventBus: SbEventBusService
    ) {
        sbEventBus
            .getObservable('CompanySelected')
            .pipe(
                filter((event) => event && event.payload),
                tap((event: SbEvent) =>
                    this.setActive(event.payload?.value?.instrumentId)
                ),
                takeUntil(this.unsubscribe$)
            )
            .subscribe();
    }

    get() {
        return this.http
            .get<Company[]>(`${this.config.get().gatewayBaseUrl}/instruments/companies`)
            .pipe(
                tap((entities) => {
                    this.companiesStore.set(entities);
                })
            );
    }

    add(company: Company) {
        this.companiesStore.add(company);
    }

    update(id, company: Partial<Company>) {
        this.companiesStore.update(id, company);
    }

    remove(instrumentId: number) {
        this.companiesStore.remove(instrumentId);
    }

    setActive(instrumentId: number) {
        this.companiesStore.setActive(instrumentId);
    }
    ngOnDestroy() {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
